import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import FeaturesGrid from '../components/FeaturesGrid';
import AutoLoadSection from '../components/AutoLoadSection';
import HowItWorks from '../components/HowItWorks';
import TrustedPartners from '../components/TrustedPartners';
import ControlPanel from '../components/ControlPanel';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <FeaturesGrid />
      <AutoLoadSection />
      <HowItWorks />
      <TrustedPartners />
      <ControlPanel />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default LandingPage;
